import { render } from "./Col8.vue?vue&type=template&id=0857903a"
import script from "./Col8.vue?vue&type=script&lang=js"
export * from "./Col8.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__